import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { nonames, nameRegExp } from "../../variables/Variables";

export default function SoleProprietorInformation({ state, onChange}) {
  function handleChange(event) {
    const { id, value } = event.target;
    const inputElement = document.getElementById(id);
    const errorElement = inputElement.nextSibling;

    if (id === "dbaname") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "Trade Name/DBA can contain only letters, numbers and & - symbols";
          errorElement.style.display = "block";
        } else if (
          !nameRegExp.test(value.trim()) ||
          nonames.includes(value.trim().toLowerCase())
        ) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML =
            "Trade Name/DBA may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <>
      <h5>Sole Proprietor Information</h5>
      <OverlayTrigger
        rootClose={true}
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Trade Name / Doing Business As</strong>
            <br />
            A trade name or doing business as name is another name under which the business or individual operates.
            These names are identified by the terms &apos;trading as&apos;(TA), &apos;doing business as&apos;(DBA), or &apos;also known as&apos;
            (AKA). To file for a DBA, a separate filing with your state and county must be completed. We will send you
            instructions on how to complete this process.
            <br />
            <br />
            The trade name may not contain any of the following endings: LLC, PLLC, LC, PA, Corp, or Inc.
          </Tooltip>
        }
      >
        <Form.Group controlId="dbaname">
          <Form.Label>Trade Name/DBA</Form.Label>
          <Form.Control
            data-hj-allow
            type="text"
            pattern="(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][pP][aA]$))(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="35"
            placeholder="Optional"
            value={state ? state.dbaname : ""}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Name cannot contain LLC.</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
